import axios from 'axios';
import toast from 'react-hot-toast';

// إنشاء instance من axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // مهم لـ Laravel Sanctum
});

// إضافة token للطلبات
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// معالجة الاستجابات والأخطاء
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const message = error.response?.data?.message || 'حدث خطأ غير متوقع';
    
    // إذا كان الخطأ 401 (غير مصرح)
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // إذا كان الخطأ 403 (ممنوع)
    if (error.response?.status === 403) {
      toast.error('ليس لديك صلاحية للوصول لهذا المورد');
    }
    
    // إذا كان الخطأ 404 (غير موجود)
    if (error.response?.status === 404) {
      toast.error('المورد المطلوب غير موجود');
    }
    
    // إذا كان الخطأ 422 (بيانات غير صحيحة)
    if (error.response?.status === 422) {
      const errors = error.response.data.errors;
      if (errors) {
        Object.values(errors).flat().forEach(error => {
          toast.error(error);
        });
      } else {
        toast.error(message);
      }
    }
    
    // إذا كان الخطأ 500 (خطأ في الخادم)
    if (error.response?.status >= 500) {
      toast.error('حدث خطأ في الخادم، يرجى المحاولة لاحقاً');
    }
    
    return Promise.reject(error);
  }
);

export default api;